export class ResultadoPrestacaoContaPontuacao{
    public id:number;
    public id_pontuacao:number;
    public valor_pontuacao:number;
    public resultado:string;
    public id_resultado_prestacao_conta:number;
}


// WEBPACK FOOTER //
// ./src/app/entity/resultado-prestacao-conta-pontuacao.model.ts